"use strict";import{css as o}from"@spectrum-web-components/base";const c=o`
a{color:inherit}a:focus{outline:none}:host(:focus-within){color:var(
--mod-tabs-color-key-focus,var(--spectrum-tabs-color-key-focus)
)}:host(:focus-within):before{border-color:var(
--highcontrast-tabs-focus-indicator-color,var(
--mod-tabs-focus-indicator-color,var(--spectrum-tabs-focus-indicator-color)
)
)}:host(:focus-within) ::slotted([slot=icon]){color:var(
--mod-tabs-color-key-focus,var(--spectrum-tabs-color-key-focus)
)}@media (forced-colors:active){:host{--highcontrast-tabs-focus-indicator-color:canvastext}}
`;export default c;
//# sourceMappingURL=top-nav-item.css.js.map
